import { useEffect, useState, useCallback, memo } from "react";
import { Tooltip } from "@mui/material";
import MyButton from "@components/atoms/MyButton/MyButton";
import { Trash } from "react-bootstrap-icons";
import { useForm } from "react-hook-form";
import { INewProduct, IProduct } from "src/types/global";
import { getCleanCurrency, getNumberCurrency } from "@utils/utils";
import { ICreateReceiptTop } from "src/types/molecules";
import CreateReceiptTopUI from "./CreateReceiptTopUI";
import { productService } from "@services/ProductService";
const CreateReceiptTop = memo(({
  setProducts,
  isLoading,
  query
}: ICreateReceiptTop) => {
  const productInitial = {
    id: -1,
    reference: "",
    description: "",
    price: "0,00",
    status: 1
  };
  const [product, setProduct] = useState<IProduct>(productInitial);
  const [customPrice, setCustomPrice] = useState(false);
  const [showError, setShowError] = useState(false);
  const {
    register,
    watch,
    setValue,
    handleSubmit,
    reset
  } = useForm<INewProduct>({
    defaultValues: {
      item: "-1",
      price: "0,00",
      totalPrice: "0,00",
      quantity: ""
    }
  });
  const productSelect = watch("item");
  const priceValue = watch("price");
  const quantityValue = watch("quantity");
  const totalPriceValue = watch("totalPrice") || "";
  const onAdd = useCallback((newProduct: INewProduct) => {
    setShowError(false);
    newProduct.productId = product.id;
    delete newProduct.item;
    newProduct.productName = product.description;
    newProduct.defaultPrice = !customPrice;
    newProduct.actions = <Tooltip title="Eliminar">
            <MyButton color="error" onClick={() => setProducts((products: INewProduct[]) => [...products.filter(p => p.productId !== newProduct.productId)])}>
              <Trash size={20} />
            </MyButton>
          </Tooltip>;
    setProducts((products: INewProduct[]) => {
      const idx = products.findIndex(p => p.productId === newProduct.productId);
      if (idx !== -1) {
        setShowError(true);
        return [...products];
      }
      reset();
      setCustomPrice(false);
      return [newProduct, ...products];
    });
  }, [product, customPrice, setProducts, reset]);
  const toggleCustomPrice = useCallback(() => {
    if (customPrice) {
      setCustomPrice(false);
      setValue("price", getCleanCurrency(product.price));
    } else {
      setCustomPrice(true);
    }
  }, [customPrice, product.price, setValue]);
  const localQuery = useCallback((rowsPerPage: number, search: string) => productService.getAll(rowsPerPage, undefined, search), []);
  useEffect(() => {
    if (productSelect && productSelect !== "-1") {
      const prod = JSON.parse(productSelect);
      setProduct(prod);
      setValue("price", getCleanCurrency(prod.price));
    } else {
      setValue("price", "0,00");
    }
  }, [productSelect, setValue]);
  useEffect(() => {
    const price = getNumberCurrency(String(priceValue));
    if (price !== 0) {
      setValue("totalPrice", getCleanCurrency(price * Number(quantityValue ? quantityValue : 0)));
    }
  }, [priceValue, quantityValue, setValue]);
  return <CreateReceiptTopUI register={register} setValue={setValue} productSelect={productSelect} customPrice={customPrice} toggleCustomPrice={toggleCustomPrice} totalPriceValue={totalPriceValue} addProduct={handleSubmit(onAdd)} showError={showError} onCloseError={() => setShowError(false)} isLoading={isLoading} query={query ? query : localQuery} />;
});
CreateReceiptTop.displayName = "CreateReceiptTop";
export default CreateReceiptTop;